module.exports = "/packs/images/svg/facilities/tracks~1aa7184ef573bc72b579d700215b8759.svg";